
  if (!customElements.get('featured-collection-tabs')) {
    customElements.define(
      'featured-collection-tabs',
      class FeaturedCollectionTabs extends HTMLElement {
        constructor() {
          super();
          this.sectionId = this.dataset.sectionId;
          this.tabNav = this.querySelector('.featured-collection-tabs__nav');
          this.contentContainer = this.querySelector('[data-tab-content]');
          this.productGrid = this.querySelector('[data-product-grid]');
          this.viewAllButton = this.querySelector('[data-view-all-button]');

          if (this.tabNav) {
            this.tabNav.addEventListener('click', this.onTabClick.bind(this));
          }
        }

        onTabClick(event) {
          const tab = event.target.closest('.featured-collection-tabs__nav-item');
          if (!tab || tab.classList.contains('active')) {
            return;
          }

          const handle = tab.dataset.collectionHandle;
          this.updateActiveTab(tab);
          this.fetchCollection(handle);
        }

        updateActiveTab(newActiveTab) {
          const currentActiveTab = this.tabNav.querySelector('.active');
          if (currentActiveTab) {
            currentActiveTab.classList.remove('active');
            currentActiveTab.setAttribute('aria-selected', 'false');
          }
          newActiveTab.classList.add('active');
          newActiveTab.setAttribute('aria-selected', 'true');
        }

        fetchCollection(handle) {
          this.contentContainer.classList.add('is-loading');
          const url = `/collections/${handle}?section_id=${this.sectionId}`;

          fetch(url)
            .then(response => response.text())
            .then(text => {
              const html = new DOMParser().parseFromString(text, 'text/html');
              const newGrid = html.querySelector('[data-product-grid]');
              if (newGrid) {
                this.productGrid.innerHTML = newGrid.innerHTML;
              }

              if (this.viewAllButton) {
                const newButton = html.querySelector('[data-view-all-button]');
                if(newButton) {
                  this.viewAllButton.href = newButton.href;
                  this.viewAllButton.innerHTML = newButton.innerHTML;
                }
              }
            })
            .catch(e => {
              console.error(e);
            })
            .finally(() => {
              this.contentContainer.classList.remove('is-loading');
            });
        }
      }
    );
  }